var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('span',{class:`subtitle-2 align-self-start ${_vm.auxTextColor}`},[_vm._v("R$")]),_c('span',{staticClass:"price mx-1"},[_vm._v(_vm._s(_vm.price))]),_c('span',{class:`caption align-self-end ${_vm.auxTextColor}`},[_vm._v("/mês")])])
}
var staticRenderFns = []

export { render, staticRenderFns }